import React, { memo } from 'react';
import { Box, Tooltip } from '@mui/material';
import parse from 'html-react-parser';
import InfoIcon from '@mui/icons-material/Info';

type Props = { title: string; infoTooltip?: string };

const TitleWithTooltip: React.FC<Props> = ({ title, infoTooltip }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
        }}
    >
        {title}
        {infoTooltip && (
            <Tooltip title={parse(infoTooltip)} key="button-element">
                <InfoIcon color="primary" sx={{ fontSize: 16 }} />
            </Tooltip>
        )}
    </Box>
);

export default memo(TitleWithTooltip);
